import Splide from "@splidejs/splide";

function initSliderStepStudy(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-step-study").forEach((el) => {
		const slides = [...el.querySelectorAll(".splide__slide")];
		const activeIndex = slides.findIndex((slide) => slide.classList.contains("--card-active"));

		const sliderStepStudy = new Splide(el, {
			mediaQuery: "min",
			perPage: 1.2,
			gap: "20px",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			omitEnd: true,
			speed: 700,
			breakpoints: {
				640: { perPage: 2.2, gap: "20px" },
				1024: { perPage: 3.2, gap: "30px" },
				1240: { perPage: 4, gap: "30px" },
			},
		});

		sliderStepStudy.mount();

		// Slide jusqu'au slide --card-active seulement s'il n'est pas entièrement visible
		if (activeIndex > 0) {
			const track = el.querySelector(".splide__track").getBoundingClientRect();
			const active = slides[activeIndex].getBoundingClientRect();
			const isVisible = active.left >= Math.floor(track.left) && active.right <= Math.ceil(track.right);

			if (!isVisible) {
				sliderStepStudy.go(activeIndex);
			}
		}
	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderStepStudy());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-slider-step-study", ($block) => {
		initSliderStepStudy($block && $block.jquery ? $block.get(0) : $block);
	});
}
